import Translator from './translator';
import Translate from './translate';

export {Translator, Translate};
